import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ROIChart from "./ROIChart";

const businessValues = [
  "$4,494,166,772",
  "$38,152,219,209",
  "$118,269,946,606",
  "$237,801,867,772",
  "$432,014,639,935",
];

const PitchMain = () => {
  return (
    <>
      <section className="py-5">
        <Container>


            <Row className="align-items-center pb-4 mb-2">
          <div className="Business-value-main-container"> 
              <div className="Business-value-container">
                <Col>
                  <p className="para">Business Value</p>
                </Col>

              </div>
              <div className="">

                <Col>
                  <div className="Business-value-container ">
                    {businessValues.map((value) => {
                      return (
                        <>
                          <div className="lighter-gray-item Business-value-box">{value}</div>
                        </>
                      );
                    })}
                  </div>
                </Col>
              </div>
          </div>
            </Row>
          <div className="scroll-x pb-3">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Avg. Ticket Price</th>
                  <th>Monthly Sales Volume per Shop</th>
                  <th>Setup Cost per Shop</th>
                  <th>Business Scenario</th>
                  <th>Cost of Capital</th>
                  <th>Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr className="active-dark">
                  <td> $152.00</td>
                  <td>480,000</td>
                  <td> $4,000,000</td>
                  <td>Unicorn</td>
                  <td>9%</td>
                  <td>15%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="scroll-x pb-5">
            <table className="custom-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Revenues</td>
                  <td> $7,660,800,000</td>
                  <td> $42,681,600,000</td>
                  <td> $99,809,280,000</td>
                  <td> $162,846,720,000</td>
                  <td> $231,575,040,000</td>
                </tr>
                <tr>
                  <td> Gross Profit</td>
                  <td> $5,668,992,000</td>
                  <td> $31,584,384,000</td>
                  <td> $73,858,867,200</td>
                  <td> $120,506,572,800</td>
                  <td> $171,365,529,600</td>
                </tr>
                <tr>
                  <td> Net Profit</td>
                  <td> $2,552,274,039</td>
                  <td> $15,410,431,575</td>
                  <td> $37,736,354,520</td>
                  <td> $64,340,361,720</td>
                  <td> $107,561,907,000</td>
                </tr>
                <tr>
                  <td> NP (%)</td>
                  <td> 33%</td>
                  <td> 36%</td>
                  <td> 38%</td>
                  <td> 40%</td>
                  <td> 46%</td>
                </tr>
                <tr>
                  <td> Break Even Revenue</td>
                  <td> $3,652,488,575</td>
                  <td> $18,181,708,784</td>
                  <td> $39,815,075,676</td>
                  <td> $60,556,796,757</td>
                  <td> $60,570,418,378</td>
                </tr>
                <tr>
                  <td> ROI</td>
                  <td> 49%</td>
                  <td> 91%</td>
                  <td> 105%</td>
                  <td> 113%</td>
                  <td> 130%</td>
                </tr>
                <tr>
                  <td> Business Value</td>
                  <td> $4,494,166,772</td>
                  <td> $38,152,219,209</td>
                  <td> $118,269,946,606</td>
                  <td> $237,801,867,772</td>
                  <td> $432,014,639,935</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <br />

          <div className="dark-box rounded-4">
            <Row className="align-items-center py-2">
              <Col md={2}>
                <p className="para">Investment Injected</p>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item flex-space">
                  <span className="para">$</span>
                  <span className="para">10,000</span>
                </div>
              </Col>
              <Col md={2}></Col>
              <Col md={2}></Col>
              <Col md={2}>
                <p className="para">Payback Period (Years)</p>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item flex-space">
                  <span className="para"></span>
                  <span className="para">1.03</span>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center py-3">
              <Col md={2}>
                <p className="para">ROI ($)</p>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">4,918</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">9,085</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">10,494</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">11,252</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">12,982</span>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center py-2">
              <Col md={2}>
                <p className="para">Acc. ROI ($)</p>
              </Col>

              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">4,918</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">14,002</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">24,496</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">35,749</span>
                </div>
              </Col>
              <Col md={2}>
                <div className="darker-gray-item mb-1 flex-space">
                  <span className="para">$</span>
                  <span className="para">48,730</span>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section>
        <Container>
          <p className="section-title fw-semibold text-start mb-2">ROI</p>
          <div className="white-box">
            <ROIChart />
          </div>
        </Container>
      </section>
      <br />
    </>
  );
};

export default PitchMain;
